import {
	HTTP_INTERCEPTORS,
	provideHttpClient,
	withInterceptors,
	withInterceptorsFromDi,
} from '@angular/common/http';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule, Routes } from '@angular/router';
import { ToastrModule } from 'ngx-toastr';
import { AppComponent } from './app.component';
import { initialize } from './app.initializer';
import { authInterceptor } from './interceptors/auth.interceptor';
import { ErrorInterceptor } from './interceptors/error.interceptor';
import { AbonnementsService } from './modules/dashboard/services/abonnements.service';
import { AuthService } from './services/auth.service';
import { UserService } from './services/user.service';
import { provideNgxMask } from 'ngx-mask';

const routes: Routes = [
	{
		path: 'welcome',
		loadChildren: () =>
			import('./modules/public/public.module').then((m) => m.PublicModule),
	},
	{
		path: 'dashboard',
		loadChildren: () =>
			import('./modules/dashboard/dashboard.module').then(
				(m) => m.DashboardModule,
			),
	},
	{
		path: '**',
		redirectTo: 'welcome',
	},
];

@NgModule({
	declarations: [AppComponent],
	bootstrap: [AppComponent],
	imports: [
		BrowserModule,
		BrowserAnimationsModule,
		FormsModule,
		ReactiveFormsModule,
		RouterModule.forRoot(routes, {
			scrollPositionRestoration: 'enabled',
		}),
		ToastrModule.forRoot(),
	],
	providers: [
		provideNgxMask(),
		AuthService,
		UserService,
		AbonnementsService,
		{
			provide: APP_INITIALIZER,
			useFactory: initialize,
			multi: true,
			deps: [AuthService],
		},
		{ provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
		provideHttpClient(
			withInterceptors([authInterceptor]),
			withInterceptorsFromDi(),
		),
	],
})
export class AppModule {}
